import {AccessInfo, UserInfo} from '@mid/sdk'
import {createContext} from 'react'

import {User} from 'catalystZeroComponents/userGuard'

export type UserContextType = (AccessInfo & UserInfo & User) | null

const UserContext = createContext<UserContextType>(null)

export default UserContext
